export const handleFail = ({ record, updateMessage }) => async () => {
  switch (record.resultCode) {
    default: {
      updateMessage(record.statusMessage ?? 'Card declined');
      break;
    }
  }
};
